import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { lighten } from "polished";

import theme from "config/theme";

import Button from "components/Button";
import Layout from "components/Layout";
import { HeroFeature } from "components/Hero";
import { ContentBlock, ActionBlock } from "components/Block";
import LatestArticles from "components/LatestArticles";
import LatestVideos from "components/LatestVideos";

import HeroSocials from "./HeroSocials";
import PressReleases from "./PressReleases";

export const PressPageTemplate = ({ page, markdown }) => {
  return (
    <>
      <HeroFeature pb={["140px", "180px"]} shade="light" content={page.hero}>
        <HeroSocials />
      </HeroFeature>
      <PressReleases content={page.articles} />
      <LatestVideos
        mt="-80px"
        content={page.videos}
        borderBottom={`1px solid ${lighten(0.04, theme.color.gray)}`}
      />
      <ContentBlock
        py={["50px", "140px"]}
        content={page.brand}
        contentShade="light"
        button={
          <Button
            mt="20px"
            as="a"
            href={`/img/${page.brand.file.relativePath}`}
          >
            {page.brand.buttonText}
          </Button>
        }
      />
      <LatestArticles content={page.blog} />
      <ActionBlock content={page.cta} shade="light" />
    </>
  );
};

// PressPageTemplate.propTypes = {
//   title: PropTypes.string
// };

const PressPage = ({ data }) => {
  const { frontmatter: page } = data.markdownRemark;
  return (
    <Layout page={page} shade="dark" footerShade="dark">
      <PressPageTemplate page={page} />
    </Layout>
  );
};

PressPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default PressPage;

export const pressPageQuery = graphql`
  query PressPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        page {
          title
        }
        hero {
          heading
          subheading
          buttonText
          buttonPath
        }
        articles {
          date
          title
          description
          path
          image {
            childImageSharp {
              fluid(maxWidth: 500, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
        videos {
          tagline
          buttonText
          buttonPath
        }
        brand {
          heading
          text
          buttonText
          file {
            relativePath
          }
          image {
            childImageSharp {
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
        blog {
          heading
        }
        cta {
          heading
          subheading
          buttonText
          buttonPath
        }
      }
    }
  }
`;
